import { useConfigurator } from '@/app/store/configurator/hooks/use-configurator';
import { Trash2Icon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Action } from '../action/action';

export const ClearAction = () => {
	const { clear } = useConfigurator();
	const { t } = useTranslation();

	return (
		<Action
			tooltip={t('actions.clear')}
			onClick={clear}
			icon={{
				component: Trash2Icon,
			}}
		/>
	);
};
